import _ from 'lodash'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  props: {
    formOptions: {
      type: Object,
      required: true
    },
    schema: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentValue: null
    }
  },
  computed: {
    width() {
      return this.schema.width || 500
    },
    suffix() {
      return this.schema.suffix || null
    },
    required() {
      const required = _.get(this, 'schema.conditional.required', null)
      if (required) {
        const requiredFieldName = this.schema.conditional.required.field
        return _.includes(this.schema.conditional.required.value, this.model[requiredFieldName])
      }
      return this.schema.required || false
    },
    v() {
      return this.$v
    },
    errorMessages() {
      let errors = []
      if (!this.v.$dirty || !this.v.$invalid) return errors

      !this.v.required && errors.push('This field is required')
      !this.v.requiredIf && errors.push('This field is required')

      return errors
    },
    modelValue() {
      return this.model[this.schema.model]
    }
  },
  watch: {
    model: {
      handler() {
        if (this.currentValue !== this.modelValue) {
          this.currentValue = this.modelValue
          this.triggerValidation()
        }
      },
      deep: true
    }
  },
  methods: {
    triggerValidation() {
      this.v.$touch()
      this.$emit('change', { model: this.schema.model, valid: !this.$v.$invalid })
    }
  },
  created() {
    this.currentValue = this.modelValue
    this.$emit('change', { model: this.schema.model, valid: !this.$v.$invalid })
  },
  validations() {
    const model = {}
    const rules = {}
    if (this.schema.required === true) {
      rules['required'] = required
    }

    if (this.schema.conditional && this.schema.conditional.required) {
      rules['requiredIf'] = requiredIf(function() {
        return (
          this.schema.conditional.required.value.indexOf(
            this.model[this.schema.conditional.required.field]
          ) !== -1
        )
      })
    }
    model[this.schema.model] = rules

    return { model }
  }
}
